import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "@vilocnv/allsetra-core";
import i18n from "i18next";
import { blockKey } from "domain/keys/api/block-key";
import { KeyActionRequestDto } from "domain/keys/entities/dtos/key-action-request.dto";

const blockKeyAction = createAsyncThunk(
  "keys/blockKeyAction",
  async (request: KeyActionRequestDto, thunkAPI) => {
    try {
      return await blockKey(request);
    } catch (error: any) {
      console.error(error);
      toast.error(i18n.t("toasts.blockKeyError"));
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export default blockKeyAction;
